class WhatsappWidget extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('[data-whatsapp-toggle]');
    this.panel = this.querySelector('[data-whatsapp-panel]');
    this.consent = this.querySelector('[data-whatsapp-consent]');
    this.link = this.querySelector('[data-whatsapp-link]');
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    if (!this.toggleButton || !this.panel) return;

    if (this.classList.contains('whatsapp-widget--avoid-newsletter') && !document.querySelector('[data-newsletter-popup-launcher]')) {
      this.classList.remove('whatsapp-widget--avoid-newsletter');
    }

    this.toggleButton.addEventListener('click', () => this.toggle());
    this.consent?.addEventListener('change', () => this.updateLinkState());
    this.link?.addEventListener('click', (event) => {
      if (this.link.classList.contains('is-disabled')) event.preventDefault();
    });

    this.updateLinkState();
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.panel.hidden = false;
    this.classList.add('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  close() {
    this.isOpen = false;
    this.classList.remove('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => {
      if (!this.isOpen) this.panel.hidden = true;
    }, 220);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  updateLinkState() {
    if (!this.link) return;

    const accepted = Boolean(this.consent?.checked);
    this.link.classList.toggle('is-disabled', !accepted);
    this.link.setAttribute('aria-disabled', accepted ? 'false' : 'true');
    if (accepted) {
      this.link.removeAttribute('tabindex');
    } else {
      this.link.setAttribute('tabindex', '-1');
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}

if (!customElements.get('whatsapp-widget')) {
  customElements.define('whatsapp-widget', WhatsappWidget);
}
